import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import Select from 'react-select';
import {
  injectTopMakesToOptions,
  skipTopMakes,
} from 'shared/components/SearchPanel/transformOptions';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import UpdatedSelect from '../../UpdatedSelect/UpdatedSelect';
import s from './SparesPanel.css';
import { sortCollection } from '../../../../shared/helpers/arrays';

class SparesPanel extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    // collapsed: PropTypes.bool.isRequired,
    //
    intl: intlShape.isRequired,
  };

  state = {
    producer: null,
    stockStatus: null,
  };

  handleProducerChange = producer => {
    const value = producer && producer.value;
    const { set } = this.props.selectedActions;

    this.setState({ producer });

    if (value === 1) {
      set.isOriginal(1);
      set.isAnalogue(null);
    } else if (value === 0) {
      set.isOriginal(null);
      set.isAnalogue(1);
    } else {
      set.isOriginal(null);
      set.isAnalogue(null);
    }
  };

  handleStockStatusChange = status => {
    const value = status && status.value;
    const { set } = this.props.selectedActions;

    this.setState({ stockStatus: status });

    if (value === 1) {
      set.inStock(1);
      set.isUnderTheOrder(null);
    } else if (value === 0) {
      set.inStock(null);
      set.isUnderTheOrder(1);
    } else {
      set.inStock(null);
      set.isUnderTheOrder(null);
    }
  };

  render() {
    const {
      formVocabulary,
      /* collapsed, */ formState,
      formData,
      selectedActions,
      intl,
    } = this.props;
    const selectedSetActions = selectedActions.set;
    const { makes, rubrics } = formVocabulary;
    const { models, sparetypes } = formData;
    const makesWithTopMakes = injectTopMakesToOptions(makes, intl);

    sortCollection(models, 'title');
    sortCollection(rubrics, 'title');
    sortCollection(sparetypes, 'title');

    const { producer, stockStatus } = this.state;

    const producers = [
      {
        title: intl.formatMessage({ id: 'Оригинальный' }),
        value: 1,
      },
      {
        title: intl.formatMessage({ id: 'Не оригинальный' }),
        value: 0,
      },
      {
        title: intl.formatMessage({ id: 'Все' }),
        value: null,
      },
    ];

    const selectedProducer =
      producer ||
      (formState.isOriginal && producers[0]) ||
      (formState.isAnalogue && producers[1]) ||
      null;

    const stockStatuses = [
      {
        title: intl.formatMessage({ id: 'В наличии' }),
        value: 1,
      },
      {
        title: intl.formatMessage({ id: 'Под заказ' }),
        value: 0,
      },
      {
        title: intl.formatMessage({ id: 'Все' }),
        value: null,
      },
    ];

    const selectedStockStatus =
      stockStatus ||
      (formState.inStock && stockStatuses[0]) ||
      (formState.isUnderTheOrder && stockStatuses[1]) ||
      null;

    return (
      <div>
        <div className={s.mainform}>
          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Марка' })}
              instanceId="make-ff"
              name="make"
              options={makesWithTopMakes}
              labelKey="title"
              valueKey="uniqueId"
              disabled={!makes || !makes.length}
              onChange={selectedSetActions.make}
              value={formState.make}
              filterOption={skipTopMakes}
            />
          </div>
          <div className={s.filterItem}>
            <UpdatedSelect
              instanceId="model-ff"
              name="model"
              placeholder={intl.formatMessage({ id: 'Модель' })}
              labelKey="title"
              valueKey="id"
              disabled={!models || !models.length}
              options={models && models.length > 0 ? models : []}
              onChange={selectedSetActions.model}
              value={formState.model}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <RegexpInput
              className={cx(s.input, s.from)}
              type="text"
              placeholder={intl.formatMessage({ id: 'Год, от' })}
              value={formState.yearFrom || ''}
              onChange={selectedSetActions.yearFrom}
              pattern={'^[0-9]+$'}
            />
            <RegexpInput
              className={cx(s.input, s.to)}
              type="text"
              placeholder={intl.formatMessage({ id: 'до' })}
              value={formState.yearTo || ''}
              onChange={selectedSetActions.yearTo}
              pattern={'^[0-9]+$'}
            />
          </div>

          {/*  */}

          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Тип' })}
              instanceId="rubrics-ff"
              name="rubrics"
              options={rubrics && rubrics.length > 0 ? rubrics : []}
              labelKey={intl.formatMessage({ id: 'locale' }) === 'uk' ? 'uk_title' : 'title'}
              valueKey="id"
              onChange={selectedSetActions.rubric}
              value={formState.rubric}
            />
          </div>
          <div className={s.filterItem}>
            <UpdatedSelect
              instanceId="sparetypes-ff"
              name="sparetypes"
              placeholder={intl.formatMessage({ id: 'Подтип' })}
              labelKey={intl.formatMessage({ id: 'locale' }) === 'uk' ? 'uk_title' : 'title'}
              valueKey="id"
              disabled={!sparetypes || !sparetypes.length}
              options={sparetypes && sparetypes.length > 0 && sparetypes.map ? sparetypes : []}
              onChange={selectedSetActions.sparetype}
              value={formState.sparetype}
              matchPos="start"
            />
          </div>

          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Тип производителя' })}
              instanceId="producer-ff"
              name="producer"
              options={producers}
              labelKey="title"
              valueKey="id"
              onChange={this.handleProducerChange}
              value={selectedProducer}
              matchPos="start"
            />
          </div>

          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Наличие запчастей' })}
              instanceId="stockStatus-ff"
              name="stockStatus"
              options={stockStatuses}
              labelKey="title"
              valueKey="id"
              onChange={this.handleStockStatusChange}
              value={selectedStockStatus}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(SparesPanel));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/SparesPanel/SparesPanel.js